/** Referral Partner Agreement — shown on the public invite / claim page. */

export const REFERRAL_PARTNER_AGREEMENT_VERSION = '2026-05-30';

export const REFERRAL_PARTNER_AGREEMENT_SECTIONS = [
  {
    title: '1. Referral relationship',
    body: `You are entering a referral partnership with Nexus Book AI ("Nexus"). As a referring partner, you may share your unique referral link with businesses you introduce to the Nexus platform. Nexus will track signups attributed to your link.`,
  },
  {
    title: '2. Commission',
    body: `Commission is earned on eligible Nexus platform subscription and add-on app charges for referred businesses, according to the commission rate and type (one-time or recurring) shown on your invite. Commissions accrue after referred businesses complete their trial and make qualifying payments. Nexus may adjust program terms with notice; terms at the time of each referral signup are snapshotted for that business.`,
  },
  {
    title: '3. Your obligations',
    body: `You agree to represent Nexus honestly, comply with applicable laws (including disclosure of referral relationships where required), and not use spam, misleading claims, or unauthorized advertising. You may not bid on Nexus trademarks as paid search keywords without written approval.`,
  },
  {
    title: '4. Payouts',
    body: `Accrued commissions are paid manually by Nexus on a schedule determined by Nexus. You are responsible for any tax obligations on amounts received. Nexus may require tax or payment information before disbursement.`,
  },
  {
    title: '5. Term & termination',
    body: `Either party may end the partnership at any time. Nexus may deactivate your referral link for violation of these terms. Commissions already accrued for valid referrals prior to termination remain subject to payout, unless reversed due to chargebacks or fraud.`,
  },
  {
    title: '6. Limitation of liability',
    body: `The referral program is provided "as is." Nexus's total liability related to the program is limited to unpaid commissions legitimately accrued for your referred businesses. This agreement is governed by the laws applicable to Nexus's operating jurisdiction.`,
  },
  {
    title: '7. Electronic signature',
    body: `By typing your full legal name and accepting below, you agree to this Referral Partner Agreement and confirm you have authority to enter into it on your own behalf (or on behalf of your organization, if applicable).`,
  },
] as const;

export function formatCommissionTerms(
  commissionPercent: number,
  commissionType: 'one_time' | 'recurring',
): string {
  const typeLabel = commissionType === 'one_time' ? 'one-time' : 'recurring';
  return `${commissionPercent}% ${typeLabel} commission on eligible platform subscription revenue`;
}
